export interface IAutocompleteOption {
	key: string;
	value: any;
	[prop: string]: any;
}
